import { useSelector } from 'react-redux'

import BaseDate from 'Component/common/base_date2';
import GraphConsensus from 'Component/graph/consensus';
import SubHead from 'Component/title/sub_head';
import renderingGuide from 'Component/title/guide_content';

const Consensus = () => {

  const { tickerDetail } = useSelector((state) => state.stock);

	return (
    <div className="content2">
      <SubHead guideType="stock" guide="consensus">
        <img src="/static/images/icon_dollar3.png" alt="" />
        <span>공정가치 및 컨센서스</span>
      </SubHead>
      { tickerDetail && tickerDetail.consensus &&
        <>
          <div className="cont">
            <BaseDate date={tickerDetail.consensus.TRD_DT} />
            <GraphConsensus data={tickerDetail.consensus} siseInfo={tickerDetail.siseInfo} />
          </div>
        </>
      }
    </div>
  );
}

export default Consensus;
